export const SET_QUIZ_PAGE = 'viewer-preview/SET_QUIZ_PAGE';
export const SET_VIDEO_LECTURE = 'viewer-preview/SET_VIDEO_LECTURE';
